import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import DefaultModal from 'Modals/DefaultModal';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
import PDFIcon from 'Icons/PDFIcon';
import bemit from 'Functions/bemit';
import { action, URL } from 'Shared/Routes';
export default class PackOrderRow extends Component {
  state = {
    loading: false
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    numeral.locale('en');
    moment.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-red']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: 'c-dashboard__row '
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrder-date"
    }, moment(data.created_at).format("DD/MM/YYYY")), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrder-hours"
    }, data.payment_type === "card" ? "Carte bancaire" : "Bon de commande"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrder-amount"
    }, data.payment_status === "paid" ? "Payée" : "En attente"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell CustomerPackOrder-login"
    }, data.total_amount_ttc + '€'));
    return output;
  }
}
